module.exports = {"360521001":"钤东街道","360521002":"钤西街道","360521100":"分宜镇","360521101":"杨桥镇","360521102":"湖泽镇","360521103":"双林镇","360521104":"钤山镇","360521105":"洋江镇","360521106":"凤阳镇","360521201":"洞村乡","360521202":"高岚乡","360521203":"操场乡","360521505":"东坑林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360521.json
// module id = 1393
// module chunks = 0